import { useEffect, useRef } from "react";
import { useStytchUser } from "@louise/api/useStytch";
import { useChatwootIdentity } from "./useChatwootIdentity";
import { ensureChatwootLoaded } from "./chatwoot.web";

export function ChatwootSessionSync() {
  const { user } = useStytchUser();
  const {
    identifier,
    isPatientLoading,
    user: chatwootUser,
    customAttributes,
  } = useChatwootIdentity();
  const previousUserId = useRef<string | null>(user?.user_id ?? null);

  useEffect(() => {
    const nextUserId = user?.user_id ?? null;
    const hasUserPayload = Object.keys(chatwootUser).length > 0;

    const syncSession = () => {
      if (
        !identifier ||
        isPatientLoading ||
        !hasUserPayload ||
        !window.$chatwoot?.setUser
      ) {
        return;
      }

      window.$chatwoot.setUser(identifier, chatwootUser);

      if (
        Object.keys(customAttributes).length > 0 &&
        typeof window.$chatwoot.setCustomAttributes === "function"
      ) {
        window.$chatwoot.setCustomAttributes(customAttributes);
      }
    };

    const handleReady = () => {
      syncSession();
    };

    ensureChatwootLoaded(handleReady);

    if (previousUserId.current && !nextUserId) {
      window.$chatwoot?.reset?.();
    }

    if (nextUserId) {
      syncSession();
    }

    previousUserId.current = nextUserId;
  }, [chatwootUser, customAttributes, identifier, isPatientLoading, user]);

  return null;
}
